import ProfileMenu from './profile-menu';

export default ProfileMenu;
